import { useState, useEffect } from 'react';
import { mapFilterNameToKey, getFilters, getDataReady } from '../../utils/util';
import { DEFAULT_FILTERS } from '../../utils/consts';

const useFilters = (props) => {
  const { masterData, filterNames, defaultFilters, selectedFilters } = props;
  const [filteredData, setFilteredData] = useState([]);

  const allFilterNames = Object.keys(defaultFilters || {}).concat(filterNames);
  let allFilters = getFilters(allFilterNames, filteredData);

  // if there're filters selected, restore the full list of filters from the original list of cards
  const selectedFilterKeys = Object.keys(selectedFilters || {});
  if (selectedFilterKeys.length > 0) {
    // Only restore the first selected filter, all the other filters are narrowed down by this selection
    const primaryFilter = selectedFilterKeys[0];
    const restoredFilters = getFilters([primaryFilter], masterData);
    allFilters = {
      ...allFilters,
      ...restoredFilters
    };
  }

  useEffect(() => {
    if (!masterData?.length) {
      return;
    }
    let _filteredData = getDataReady(masterData, defaultFilters);

    if (Object.keys(selectedFilters || {}).length) {
      try {
        Object.keys(selectedFilters).forEach((filterType) => {
          const availableFilters = allFilters[filterType];
          const selectedFiltersForType = selectedFilters[filterType];
          let filters =
            filterType === Object.keys(DEFAULT_FILTERS)[0]
              ? selectedFiltersForType
              : selectedFiltersForType.filter((fl) => availableFilters.includes(fl));
          if (!filters.length) {
            filters = [availableFilters[0]];
          }
          _filteredData = _filteredData.filter((data) => {
            const allKeys = Object.keys(data);
            const key = mapFilterNameToKey(filterType, allKeys);
            const target = data[key];
            if (target && target.constructor === Array && target.length > 0) {
              const hasTheTarget = target.find((tg) => filters.some((ft) => ft === tg));
              return hasTheTarget;
            }
            if (target && typeof target === 'string') {
              return filters.find((fl) => fl === target);
            }
            if (filters.find((ft) => data[ft])) {
              return true;
            }
            return false;
          });
        });
      } catch (err) {
        //
      }
    }
    setFilteredData(_filteredData);
  }, [selectedFilters, masterData]);

  return {
    filteredData,
    allFilters
  };
};

export default useFilters;
